var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDC69\\u200D\\uD83C\\uDF93-Students-management",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Platform-Admin-/-Dashboard-/-Manage-Students-/-Total-Count",
    transform: "translate(-120, -178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stats",
    transform: "translate(96, 152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(24, 24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Copy-3",
    transform: "translate(0, 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Base",
    fill: "#172E4B",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(11, 10)",
    fill: "#438AE0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "users",
    transform: "translate(13.5, 13.5) scale(1, -1) rotate(-180) translate(-13.5, -13.5)translate(-0, 4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.05,7.71428571 C5.53921875,7.71428571 6.75,6.56116071 6.75,5.14285714 C6.75,3.72455357 5.53921875,2.57142857 4.05,2.57142857 C2.56078125,2.57142857 1.35,3.72455357 1.35,5.14285714 C1.35,6.56116071 2.56078125,7.71428571 4.05,7.71428571 Z M22.95,7.71428571 C24.4392187,7.71428571 25.65,6.56116071 25.65,5.14285714 C25.65,3.72455357 24.4392187,2.57142857 22.95,2.57142857 C21.4607812,2.57142857 20.25,3.72455357 20.25,5.14285714 C20.25,6.56116071 21.4607812,7.71428571 22.95,7.71428571 Z M24.3,9 L21.6,9 C20.8575,9 20.1867187,9.28526786 19.6973437,9.74732143 C21.3975,10.6352679 22.6040625,12.2383929 22.865625,14.1428571 L25.65,14.1428571 C26.3967187,14.1428571 27,13.5683036 27,12.8571429 L27,11.5714286 C27,10.153125 25.7892187,9 24.3,9 Z M13.5,9 C16.1114062,9 18.225,6.98705357 18.225,4.5 C18.225,2.01294643 16.1114062,0 13.5,0 C10.8885937,0 8.775,2.01294643 8.775,4.5 C8.775,6.98705357 10.8885937,9 13.5,9 Z M16.74,10.2857143 L16.3898437,10.2857143 C15.5123437,10.6875 14.5378125,10.9285714 13.5,10.9285714 C12.4621875,10.9285714 11.491875,10.6875 10.6101562,10.2857143 L10.26,10.2857143 C7.576875,10.2857143 5.4,12.3589286 5.4,14.9142857 L5.4,16.0714286 C5.4,17.1361607 6.30703125,18 7.425,18 L19.575,18 C20.6929687,18 21.6,17.1361607 21.6,16.0714286 L21.6,14.9142857 C21.6,12.3589286 19.423125,10.2857143 16.74,10.2857143 Z M7.30265625,9.74732143 C6.81328125,9.28526786 6.1425,9 5.4,9 L2.7,9 C1.21078125,9 -9.42743622e-14,10.153125 -9.42743622e-14,11.5714286 L-9.42743622e-14,12.8571429 C-9.42743622e-14,13.5683036 0.60328125,14.1428571 1.35,14.1428571 L4.13015625,14.1428571 C4.3959375,12.2383929 5.6025,10.6352679 7.30265625,9.74732143 Z",
    id: "Shape"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsers);
export default __webpack_public_path__ + "static/media/icon-users.a2c6e61c.svg";
export { ForwardRef as ReactComponent };